import axios from "axios";

export const CPT_API = "cpt";

export const getAllCpts = () => {
  return axios.get(`${CPT_API}`);
}

export const searchCpts = (query) => {
  return axios.get(`${CPT_API}?search=${query}`);
} 